<template>
  <div id="app">
    <!-- <SignInHeader /> -->
    <main>
      <router-view />
    </main>
    <SignInFooter />
  </div>
</template>

<script setup>
// import SignInHeader from '@/components/SignInHeader.vue';
import SignInFooter from '@/components/SignInFooter.vue';
</script>

<style lang="scss">
@import '@/scss/signin.scss';

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-image: url('@/assets/images/background.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;

  > main {
    flex: 1;
    max-width: 1500px;
    width: 100%;
    margin: 0 auto;
    padding: 2rem 1.5rem;
  }
}
</style>
